import React, {Component} from 'react';
import { get, post } from '../utils/request';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { regExpression, isPhone, constant, scrollToAnchor } from '../utils/util';


// Common Textarea
class CommonTextarea extends Component {
  static defaultProps = {
    title: '',
    name: '',
    value: '',
    holder: '',
    checkErr: false,
    maxLength: 2000
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = (this.props.checkErr && !!!this.props.value) || (this.props.value.length > this.props.maxLength);
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <textarea
          className={classShowName}
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
          placeholder={this.props.holder}
        />
        { showErr && <span className="err-tips narrow-err-tips">{this.props.holder }</span> }
      </div>
    )
  }
}

// Common Input
class CommonInput extends Component {
  static defaultProps = {
    name: '',
    title: '',
    holder: '',
    value: '',
    checkErr: false,
    errorMsg: '',
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.value;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <input
          type="text"
          className={classShowName}
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">{this.props.errorMsg}</span> }
      </div>
    )
  }
}

class CommonOptionSelect extends Component {
  static defaultProps = {
    showDefaultOption: true, 
    selectedVal: '',
    name: '',
    title: '',
    option_list: [],
  }
  constructor(props) {
    super(props);
    this.state = {
      ...props
    };
    // console.log("----------- CommonOptionSelect 111 select ---> " + JSON.stringify(this.state))
  }


  handleChange = (event) => {
    const [key, value] = [event.target.name, event.target.value];

    this.setState({
      selectedVal : value
    })
    this.props.onSelectOption({
      [key]: value,
      selectedVal : value
    })
    // console.log("CommonOptionSelect 222 select --->" + JSON.stringify(this.state))
  }

  render() {
    const showErr = this.props.checkErr && !!!this.props.selectedVal;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <select className={classShowName} name={this.props.name} value={this.props.selectedVal} onChange={this.handleChange}>
          {
            this.props.showDefaultOption && <option value="">请选择</option>
          }
          {
            this.props.option_list && this.props.option_list.map(val => {
              return <option key={val && val.toString() || ''} value={val}>{val}</option>
            })
          }
        </select>
        { showErr && <span className="err-tips">请选择</span> }
      </div>
    )
  }
}

// 项目方向
class Kryptis extends Component {
  static defaultProps = {
    kryptis: ''
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleChange = (event) => {
    this.setState({
      kryptis: event.target.value
    })
    this.props.returnData({kryptis: event.target.value});
  }
  render() {
    return (
      <select className={this.props.classReName} value={this.state.kryptis} onChange={this.handleChange}>
        <option value="">请选择</option>
        {
          this.props.kryptisData && this.props.kryptisData.map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

// 项目领域
class Laukas extends Component {
  static defaultProps = {
    laukas: '',
    kryptis: ''
  }
  handleChange = (event) => {
    this.setState({
      laukas: event.target.value
    })
    this.props.returnData({laukas: event.target.value});
  }
  render() {
    this.state = {...this.props};
    const classShowName = `${this.props.classReName} right`;
    return (
      <select className={classShowName} value={this.state.laukas} onChange={this.handleChange}>
        <option value="">请选择</option>
        { this.props.kryptis &&
          this.props.laukasData[this.props.kryptis] && this.props.laukasData[this.props.kryptis].map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

// 项目方向领域组件
class KryptisLaukas extends Component {
  static defaultProps = {
    kryptis: '',
    laukas: '',
    recive_title: '',
    industryData: {
      first: [],
      second: []
    }
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  componentWillReceiveProps(nextProps) {
  }
  handleData = (resJson) => {
    // 设置kryptis值
    resJson.hasOwnProperty("kryptis") && this.setState({
      kryptis: resJson['kryptis'],
      laukas: ''
    })

    // 设置laukas值
    resJson.hasOwnProperty("laukas") && this.setState({
      laukas: resJson['laukas'],
    })

    // 回传值
    this.props.onValueChange({
      kryptis: resJson.hasOwnProperty("kryptis") ? resJson['kryptis'] : this.state.kryptis,
      laukas: resJson['laukas'] ? resJson['laukas'] : ''
    })
  }
  showErr = (kryptis, laukas) => {
    if (this.props.checkErr && (!!!kryptis || !!!laukas)) {
      return <span className="err-tips">{ this.props.errorMsg || '请选择' } </span>
    }
    return null;
  }
  componentDidMount () {
    var self = this
    get('/fancube/project/industry')
    .then(res => {
      if (res.code === 200) {
        this.setState({
          industryData: res.data
        });
      }
    })
  }
  render() {
    const showErrKryptis = this.props.checkErr && !!!this.state.kryptis;
    const showErrLaukas = this.props.checkErr && !!!this.state.laukas;
    const errk = showErrKryptis ? 'err-s' : '';
    const errL = showErrLaukas ? 'err-s' : '';
    const classShowKrName = `s-select ${errk}`;
    const classShowLaName = `s-select ${errL}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.recive_title || '项目方向/领域：' }</label>
        <Kryptis kryptis={this.state.kryptis} kryptisData={this.state.industryData.first} returnData={this.handleData} classReName={classShowKrName} />
        <Laukas  laukas={this.state.laukas} kryptis={this.state.kryptis} laukasData={this.state.industryData.second} returnData={this.handleData} classReName={classShowLaName}/>
        {this.showErr(this.state.kryptis, this.state.laukas)}
      </div>
    )
  }
}


// 搜索 input select
class CompanyName extends Component {
  constructor (props) {
    super(props)
    this.state = {
      companyNameList :[],
      showMask: false,
    }
  }
  static defaultProps = {
    company: ''
  }
  componentDidMount() {
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
    this.getOrgList(e.target.value)
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.company;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item ">
        <label className="s-label">公司名称：</label>
        <div className="input-dropdown-wrap">
          <input
            type="text"
            className={classShowName}
            name="company_name"
            value={this.props.company}
            onChange={this.handleChange}
          />
          {
            this.state.showMask &&
            <div className="drop-list">
              {
                this.state.companyNameList.map((company) => {
                  return <div 
                          className="drop-item" 
                          key={company.id}
                          onClick={ ()=> {
                            this.props.onValueChange({
                              company_name:company.name,
                            })
                            this.setState({
                              companyNameList: [],
                              showMask: false
                            })
                          }}
                          >{company.name}</div>
                })
              }
            </div>
          }
          {this.state.showMask && 
            <div 
              className="select-mask" 
              onClick={()=>{
                this.setState({
                  showMask: false
                })
              }}
            ></div> 
          }
        </div>
        { showErr && <span className="err-tips">请填写</span> }
      </div>
    )
  }
  getOrgList = (keyword) => {
    this.setState({
      companyNameList: [],
      showMask: true
    })
    var self = this
    get('/fancube/search_company/',{
      params:{'name': keyword}
    })
    .then( res => {
      self.setState({
        companyNameList: res.data.company_list
      })
    })
  }
}


export {
  CommonInput,
  CommonTextarea,
  CommonOptionSelect,
  KryptisLaukas,
  CompanyName
}